import { render, staticRenderFns } from "./DayAgendaListItem.vue?vue&type=template&id=56060e88&scoped=true"
import script from "./DayAgendaListItem.vue?vue&type=script&lang=js"
export * from "./DayAgendaListItem.vue?vue&type=script&lang=js"
import style0 from "./DayAgendaListItem.vue?vue&type=style&index=0&id=56060e88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56060e88",
  null
  
)

export default component.exports